import { render, staticRenderFns } from "./certificateList.vue?vue&type=template&id=b450bed6&scoped=true"
import script from "./certificateList.vue?vue&type=script&lang=js"
export * from "./certificateList.vue?vue&type=script&lang=js"
import style0 from "./certificateList.vue?vue&type=style&index=0&id=b450bed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450bed6",
  null
  
)

export default component.exports